import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { navLinks } from "../header/Header";

const BreadcrumbsNav = () => {
  const location = useLocation();


  const pathnames = location.pathname.split("/").filter((x) => x);
const filteredPathnames = pathnames.filter(
  (segment) => isNaN(segment)
);
  const formatName = (str) =>
    str
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator="›"
      sx={{
        "& .MuiLink-root, & .MuiTypography-root": {
          fontSize: {
            xs: "0.75rem",
            sm: "0.85rem",
            md: "0.95rem",
            lg: "1rem",
            xl: "1.05rem",
          },
        },
      }}
    >
      <Link
        component={RouterLink}
        to="/"
        underline="hover"
        color="primary"
      >
        Home
      </Link>

      {/* {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;

        return isLast ? (
          <Typography key={routeTo} color="secondary.light" >
            {formatName(name)}
          </Typography>
        ) : (
          <Link
            key={routeTo}
            component={RouterLink}
            to={routeTo}
            underline="hover"
            color="inherit"
          >
            {formatName(name)}
          </Link>
        );
      })} */}
      {/* {pathnames
        .filter((segment) => isNaN(segment)) // ⬅️ hides numeric IDs
        .map((name, index) => {
          const filteredPathnames = pathnames.filter((segment) => isNaN(segment));
          const routeTo = `/${filteredPathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === filteredPathnames.length - 1;

          return isLast ? (
            <Typography key={routeTo} color="secondary.light">
              {formatName(name)}
            </Typography>
          ) : (
            <Link
              key={routeTo}
              component={RouterLink}
              to={routeTo}
              underline="hover"
              color="inherit"
            >
              {formatName(name)}
            </Link>
          );
        })} */}


{filteredPathnames.map((segment, index) => {
  const routeTo = `/${filteredPathnames
    .slice(0, index + 1)
    .join("/")}`;

  const isLast = index === filteredPathnames.length - 1;

  const matchedLink = navLinks.find(
    (link) => link.href === routeTo
  );

  const displayName = matchedLink
    ? matchedLink.title
    : formatName(segment);

  return isLast ? (
    <Typography key={routeTo} color="secondary.light">
      {displayName}
    </Typography>
  ) : (
    <Link
      key={routeTo}
      component={RouterLink}
      to={routeTo}
      underline="hover"
      color="inherit"
    >
      {displayName}
    </Link>
  );
})}


    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;
